import React from 'react';
import { Phone, ArrowLeft, MapPin } from 'lucide-react';
import { useNavigate, Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import VillesVoisines from '../components/VillesVoisines';
import AvisVille from '../components/AvisVille';

const ReparationIPhoneLHorme = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <nav className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
          <button onClick={() => navigate('/')} className="flex items-center gap-2 text-gray-700">
            <ArrowLeft className="w-5 h-5" /><span>Retour</span>
          </button>
          <a href="tel:0773601521" className="flex items-center gap-2 text-gray-700">
            <Phone className="w-4 h-4" /><span className="font-medium">07.73.60.15.21</span>
          </a>
        </div>
      </nav>

      <section className="bg-gradient-to-br from-[#1a2332] to-[#1e2a3d] text-white py-16 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 bg-blue-500/20 border border-blue-400 rounded-full px-4 py-2 mb-6">
            <MapPin className="w-4 h-4" /><span>À 5 km de L'Horme</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Réparation iPhone à L'Horme</h1>
          <p className="text-xl text-gray-300 mb-8">Atelier proche de L'Horme - Écran, batterie, garantie 3 mois</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="tel:0773601521"><Button className="bg-green-500 hover:bg-green-600 text-white px-8 py-6 text-lg"><Phone className="w-5 h-5 mr-2" />07.73.60.15.21</Button></a>
            <Link to="/rendez-vous"><Button className="bg-blue-500 hover:bg-blue-600 text-white px-8 py-6 text-lg">Prendre RDV</Button></Link>
          </div>
        </div>
      </section>

      <section className="py-16 px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-8">Réparations iPhone pour L'Horme</h2>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-xl font-bold mb-3">Écran iPhone</h3>
              <p className="text-gray-600 mb-2">Remplacement d'écran cassé</p>
              <div className="text-blue-600 font-bold">Devis gratuit</div>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-xl font-bold mb-3">Batterie</h3>
              <p className="text-gray-600 mb-2">Changement de batterie</p>
              <div className="text-blue-600 font-bold">Devis gratuit</div>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-xl font-bold mb-3">Autres</h3>
              <p className="text-gray-600 mb-2">Connecteur, caméra, etc.</p>
              <div className="text-blue-600 font-bold">Sur devis</div>
            </div>
          </div>
          <div className="text-center mt-8">
            <Link to="/rendez-vous"><Button className="bg-blue-500 hover:bg-blue-600 text-white px-8 py-4">Devis gratuit</Button></Link>
          </div>
        </div>
      </section>

      <section className="py-16 px-4 bg-blue-600 text-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-6">iPhone cassé à L'Horme ?</h2>
          <p className="text-xl mb-8">Intervention rapide - Atelier à Saint-Chamond (5 km)</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="tel:0773601521" className="text-2xl font-bold">📞 07.73.60.15.21</a>
            <Link to="/rendez-vous"><Button className="bg-white text-blue-600 px-8 py-4">Prendre RDV</Button></Link>
          </div>
        </div>
      </section>

      <AvisVille slug="lhorme" nom="L'Horme" />

      <VillesVoisines slug="lhorme" />

      <footer className="bg-gray-900 text-white py-8 px-4 text-center">
        <p className="text-gray-400">© 2026 Suro Phone - Réparation iPhone L'Horme</p>
      </footer>
    </div>
  );
};

export default ReparationIPhoneLHorme;
